import styled from 'styled-components';

export const AgencyInformationWrapper = styled.div``;
